.popover {
	display: flex;
	flex-direction: column;
	min-height: 0;
	padding: var(--size-4);
	gap: var(--size-4);
	width: 18rem;

	.machine {
		display: flex;
		align-items: center;
		gap: var(--size-3);
		font-weight: 600;
		width: 100%;

		.text {
			flex: 1;
			min-width: 0;
		}

		> svg {
			color: var(--color-text-subtle);
			padding: 2px;
		}
	}
}
